module.exports = __webpack_public_path__ + "static/img/h-3.8464a221.png";